export default __webpack_public_path__ + "static/media/Rectangle_89.3837462e.png";